import IState from '@/store/modules/nav/IState.ts'

const state: IState = {
    collapsed: false,
    closed: true,
}

export default state
